import React from "react";

import {
  Card,
  CardBody,
  CardTitle,
  Content,
  Grid,
  GridItem,
  Icon,
  PageSection,
  Stack,
  StackItem,
  LabelGroup,
  Label
} from "@patternfly/react-core";

import {
  BookIcon,
  DatabaseIcon,
  GraduationCapIcon,
  NetworkWiredIcon
} from "@patternfly/react-icons";


const subjectGroupIcons = {
  "hardware-and-systems": BookIcon,
  networks: NetworkWiredIcon,
  "web-and-databases": DatabaseIcon,
  "vocational-preparation": GraduationCapIcon
};


const EducationDirectionSubjects = ({
  subjectGroups = []
}) => {
  if (!subjectGroups.length) {
    return null;
  }

  return (
    <PageSection
      id="subjects"
      className="education-direction-section"
      isWidthLimited
      aria-labelledby="education-direction-subjects-title"
    >
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <Content
                style={{
                  textAlign: "center"
                }}
              >
                <h2 id="education-direction-subjects-title">
                  Przedmioty zawodowe
                </h2>

                <p>
                  Podczas nauki będziesz uczestniczyć
                  w zajęciach teoretycznych i praktycznych
                  przygotowujących do pracy w zawodzie.
                </p>
              </Content>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid hasGutter>
            {subjectGroups.map((group) => {
              const SubjectGroupIcon =
                subjectGroupIcons[group.id];

              return (
                <GridItem
                  key={group.id}
                  span={12}
                  md={6}
                >
                  <Card
                    isGlass
                    isFullHeight
                  >
                    <CardTitle>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap:
                            "var(--pf-t--global--spacer--md)"
                        }}
                      >
                        {SubjectGroupIcon && (
                          <Icon
                            size="lg"
                            // status="info"
                          >
                            <SubjectGroupIcon />
                          </Icon>
                        )}

                        <Content>
                          <h3>{group.title}</h3>
                        </Content>
                      </div>
                    </CardTitle>

                    <CardBody>
                      {/* <List> */}
                      <LabelGroup
                        collapsedText='${remaining} więcej'
                        expandedText='Pokaż mniej'
                        defaultIsOpen={true}
                      >
                        {/* {group.subjects.map((subject) => (
                          // <ListItem key={subject}>
                          <Label>
                            {subject}
                          </Label>
                          // </ListItem>
                        ))} */}
                        {group.subjects.map((subject, index) => (
                          <Label key={`${group.id}-${subject}-${index}`}>
                            {subject}
                          </Label>
                        ))}
                      </LabelGroup>
                      {/* </List> */}
                    </CardBody>
                  </Card>
                </GridItem>
              );
            })}
          </Grid>
        </StackItem>
      </Stack>
    </PageSection>
  );
};


export default EducationDirectionSubjects;